import { getAllCountries } from '@wix/locale-dataset-javascript'

import { CountryCode } from './types'

export const ALL_COUNTRY_CODES: CountryCode[] = getAllCountries().map(country => ({
  key: country.key,
  dialCode: country.dialCode,
  shortKey: country.shortKey,
}))

export const DEFAULT_COUNTRY_CODE = ALL_COUNTRY_CODES.find(country => country.key === 'USA')!
